import { useTranslation } from "react-i18next";
import * as S from "./styles";

interface ExploreItemsHeaderProps {
  page: "filters" | "table";
  handleSelectPage: (page: "filters" | "table") => void;
}

export function ExploreItemsHeader({
  handleSelectPage,
  page,
}: ExploreItemsHeaderProps) {
  const { t } = useTranslation();

  return (
    <S.CreateStoreStepsContainer>
      <S.StepsButton
        active={page === "filters"}
        onClick={() => handleSelectPage("filters")}
      >
        {t("selectedFilters")}
      </S.StepsButton>
      <S.StepsButton
        active={page === "table"}
        onClick={() => handleSelectPage("table")}
      >
        {t("table")}
      </S.StepsButton>
    </S.CreateStoreStepsContainer>
  );
}
